module.exports = new __parcel__URL__("no2--dataset-cover.80478047.jpg").toString();